import React from 'react';
import { Card, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function LoadingCollectionCard() {
	return (
		<Col lg={4} md={6} xs={12}>
			<Link to={'#'}>
				<Card className='cisadgccrd'>
					<Card.Header
						variant='top'
						className='ci-crd-imgc lazy animated'
						style={{ height: '200px' }}
						loading='lazy'
					></Card.Header>
					<Card.Body>
						<Card.Title>
							<div className='isadgid animated'>...</div>
							<span className='animated w-100 d-inline-block mt-1'>
								...
							</span>
						</Card.Title>
					</Card.Body>
				</Card>
			</Link>
		</Col>
	);
}
